import FindContainer from "../features/find/FindContainer";
const Find = () => {
  return <FindContainer />;
};
export default Find;
